import { Controller } from '@hotwired/stimulus'
import $ from 'jquery'
import { Modal } from 'bootstrap'

/*
 * DDT-4126: the "Honoraires facturés" pop-up (_components/invoiced_fee_modal.html.twig). Opened by
 * the case-billing controller through an `invoiced-fee:open` window event with the line to edit
 * (or none for a new line) and the save URL. The amount is mandatory; on save it hands the
 * server's response on as `case-billing:saved`, like the in-place expected-fee edit.
 */
/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['form', 'amount', 'missionType', 'error', 'submit']

    connect() {
        this.modal = Modal.getOrCreateInstance(this.element)
        this.request = null
    }

    open(event) {
        this.request = event.detail

        const amount = event.detail.amount
        this.amountTarget.value = amount === null || amount === undefined || amount === '' ? '' : String(amount)

        const missionTypes = event.detail.missionTypes || []
        this.missionTypeTargets.forEach(input => {
            input.checked = missionTypes.includes(input.value)
        })

        this.hideError()
        this.submitTarget.disabled = false
        this.modal.show()
    }

    keepDigits(event) {
        event.target.value = event.target.value.replace(/\D/g, '')

        if (event.target.value !== '') {
            this.hideError()
        }
    }

    save(event) {
        event.preventDefault()

        if (!this.request) {
            return
        }

        if (this.amountTarget.value === '') {
            this.showError(this.element.dataset.requiredMessage)

            return
        }

        this.submitTarget.disabled = true

        const { chatId } = this.request

        $.ajax({
            url: this.request.url,
            method: 'POST',
            data: {
                amount: this.amountTarget.value,
                invoicedFeeId: this.request.invoicedFeeId || '',
                missionTypes: this.missionTypeTargets.filter(input => input.checked).map(input => input.value),
            },
            success: result => {
                this.modal.hide()
                window.dispatchEvent(new CustomEvent('case-billing:saved', { detail: { chatId, result } }))
            },
            error: xhr => {
                this.showError((xhr.responseJSON && xhr.responseJSON.message) || translations['profile.An unknown error occurred.'])
            },
            complete: () => {
                this.submitTarget.disabled = false
            },
        })
    }

    showError(message) {
        this.errorTarget.textContent = message
        this.errorTarget.classList.remove('d-none')
        this.amountTarget.setAttribute('aria-invalid', 'true')
    }

    hideError() {
        this.errorTarget.classList.add('d-none')
        this.amountTarget.removeAttribute('aria-invalid')
    }
}
